module.exports = __webpack_public_path__ + "img/gb9877_1-88-65x90x10.prt.2b5339cc.jpg";